<template>
  <v-app>
    <v-container class="appclick">
      <Header>
        <font-awesome-icon :icon="['fas', 'diagnoses']" />
        <font-awesome-icon :icon="['fas', 'cogs']" />
        <font-awesome-icon :icon="['fas', 'vector-square']" />
        <span class="title">Define or change movementzones</span>
      </Header>
      <v-row>
        <v-col class="col-12">
          <div id="map" class="map"></div>
          <div id="tekst"></div>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="col-6">
          <v-button id="on">Edit or Create zone</v-button>&nbsp;&nbsp;
          <v-button id="save" @click.native="ClickSave()">Save zone</v-button>
          <v-button id="delete">Delete zone</v-button>
          <button @click="ClickRecreate">Recreate routes</button>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="col-8">
          <v-subheader
            >Number of loose ends to show with current settings</v-subheader
          ><br />
          <h4>Reduction of frames</h4>
          <li>
            On subsequent frames where the object remains exactly on the same
            position were deleted
          </li>
          <li>
            The first frame of an object is deleted (mostly this is a dummy
            frame)
          </li>
          <li>
            NEW: Some objects changed often between a real zone and zone 0. The
            number of frames for zone 0 is often 1 or 2. We skip if less than 5.
          </li>
        </v-col>
        <v-col class="col-1 col-middle">
          <v-text-field
            v-model="field.field_zones_ntest"
            type="number"
            background-color="#42B98340"
            min="0"
            outlined
            @change="field_update('field_zones_ntest', field.field_zones_ntest)"
          >
          </v-text-field>
        </v-col>
        <v-col class="col-2 col-middle">
          <v-subheader>
            <router-link :to="{ name: 'settings_zones_test' }"
              ><font-awesome-icon
                class="appclick"
                :icon="['fas', 'balance-scale']"
              /><span class="title">Do test</span></router-link
            >
          </v-subheader>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>
<script>
import ProjectService from "@/services/ProjectService.js";
import Header from "@/components/Header.vue";
import Button from "@/components/BaseButton.vue";
import Map from "ol/Map";
import View from "ol/View";
import "ol/ol.css";
import { Draw, Modify, Snap, Select } from "ol/interaction";
import VectorSource from "ol/source/Vector";
import VectorLayer from "ol/layer/Vector";
import Static from "ol/source/ImageStatic";
import { getCenter } from "ol/extent";
import ImageLayer from "ol/layer/Image";
import GeoJSON from "ol/format/GeoJSON";
import Projection from "ol/proj/Projection";
import { Fill, Stroke, Style, Text } from "ol/style";
var vectorsource;
var vectorlayer;
var image;
//var draw;
var extent = [0, 0, 720, 480];
var projection = new Projection({
  code: "static-image",
  units: "pixels",
  extent: extent
});

export default {
  components: {
    Header,
    "v-button": Button
  },
  data() {
    return {
      selectId: 99,
      vectorlayer: null,
      verctorsource: null,
      image: null,
      draw: null,
      map: null,
      i: 1,
      event: {},
      field: {},
      field_extra: {},
      zones: {}
    };
  },
  mounted() {
    ProjectService.apiGet({
      nid: this.$session.get("PROJID"),
      type: "settings_zones"
    })
      .then(response => {
        this.zones = response.data.zones;
        //console.log(this.zones);
        this.field = response.data.fields;
        this.DefineVars();
        //this.ShowZones();
      })
      .catch(error => {
        let message = {
          title: "Error " + error.response
        };
        this.$dialog.alert(message);
        console.log("Fout " + error.response);
      });
  },
  methods: {
    ClickRecreate() {
      this.$dialog
        .confirm(
          "Routes will be recreated. Please click Continue to continue and wait for Ok screen."
        )
        .then(function() {
          //console.log(dialog);
          //console.log("Yes");
        })
        .catch(function() {
          //console.log("No");
        });
      this.ClickRecreatePost();
    },
    ClickRecreatePost() {
      ProjectService.apiPost({
        nid: this.$session.get("PROJID"),
        type: "settings_zones_recreate"
      })
        .then(response => {
          if (response.data == "Ok") {
            this.$dialog.alert("Routes are recreated");
          } else {
            this.$dialog.alert("Recreating routes failed");
          }
        })
        .catch(error => {
          console.log("Fout " + error.response);
        });
    },
    DefineVars() {
      function styleFunction(feature) {
        var att = feature.getProperties();
        return [
          new Style({
            fill: new Fill({
              color: "rgba(255, 0, 0, 0.2)"
            }),
            stroke: new Stroke({
              color: "#0000ff",
              width: 2
            }),
            text: new Text({
              font: "40px Calibri,sans-serif",
              fill: new Fill({ color: "#000" }),
              text: "" + att.id
            })
          })
        ];
      }
      vectorsource = new VectorSource({
        features: new GeoJSON().readFeatures(this.zones)
      });
      vectorlayer = new VectorLayer({
        source: vectorsource,
        style: styleFunction
      });
      image = new ImageLayer({
        source: new Static({
          url:
            "https://trafficdistillery.com/sites/default/files/project/" +
            this.$session.get("PROJID") +
            "/SCUCCW.jpg",
          projection: projection,
          size: [720, 480],
          imageExtent: extent
        })
      });
      var map = new Map({
        layers: [image, vectorlayer],
        target: "map",
        controls: [],
        interactions: [],
        view: new View({
          projection: projection,
          center: getCenter(extent),
          zoom: 1.3,
          attribution: false
        })
      });
      var draw = new Draw({
        source: vectorsource,
        features: this.zones,
        minpoints: 3,
        type: "Polygon"
      });
      var modify = new Modify({ source: vectorsource });
      var snap = new Snap({ source: vectorsource });
      var select = new Select({ source: vectorsource });
      map.addInteraction(draw);
      map.addInteraction(snap);
      map.addInteraction(modify);
      map.addInteraction(select);

      map.removeInteraction(select);
      map.removeInteraction(draw);
      map.removeInteraction(snap);
      map.removeInteraction(modify);

      select.on("select", function(evt) {
        console.log(evt);
        if (typeof evt.selected[0] !== "undefined") {
          var id = evt.selected[0].values_.id;
          this.selectId = id;
          console.log(id);
          //          this.$dialog.ale.alert("ID ");
          //this.$dialog.alert("Routes are recreated");
          // + this.selectId
          var features = vectorsource.getFeatures();
          for (var x in features) {
            if (features[x].values_.id == id) {
              //vectorsource.removeFeature(features[x]);
              break;
            }
          }
        }
      });
      function map_interaction(interaction) {
        console.log(interaction);
        map.removeInteraction(draw);
        map.removeInteraction(snap);
        map.removeInteraction(modify);
        map.removeInteraction(select);
        switch (interaction) {
          case "on":
            map.addInteraction(draw);
            map.addInteraction(snap);
            map.addInteraction(modify);
            break;
          case "off":
            break;
          case "delete":
            map.addInteraction(select);
            break;
        }
      }
      document.getElementById("on").onclick = function() {
        map_interaction("on");
      };
      document.getElementById("delete").onclick = function() {
        alert(this.selectId);
        //map_interaction("delete");
      };
      map.on("pointermove", function(evt) {
        var coordinate =
          "X " +
          Math.round(evt.coordinate[0] * 10) / 10 +
          " Y " +
          Math.round(evt.coordinate[1] * 10) / 10;

        document.getElementById("tekst").innerHTML = coordinate;
      });
    },
    field_update(field, value) {
      ProjectService.apiPost({
        nid: this.$session.get("PROJID"),
        type: "update_fields",
        field,
        value
      });
    },
    ClickSave() {
      console.log("!!!!");
      var features = vectorsource.getFeatures();
      var i = 101;
      var zones = {};
      features.forEach(function(feature) {
        let cid = feature.getProperties().id;
        if (isNaN(cid)) {
          cid = i;
          i++;
        }
        zones[cid] = feature.getGeometry().getCoordinates();
      });
      console.log(zones);
      ProjectService.apiPost({
        nid: this.$session.get("PROJID"),
        type: "settings_zones_save",
        vars: zones
      });
      //this.GetZones();
    }
  }
};
</script>
<style scoped>
.map {
  background-color: lightgray;
  height: 420px;
  padding: 0px;
  width: 630px;
  margin-left: 10px;
}
#on,
#save {
  background: linear-gradient(to right, #16c0b0, #84cf6a);
}

#delete,
#recreate {
  background: linear-gradient(to right, #ff0000, #660000);
}

.location {
  margin-bottom: 0;
}
.location > .icon {
  margin-left: 10px;
}
.event-header > .title {
  margin: 0;
}
.list-group {
  margin: 0;
  padding: 0;
  list-style: none;
}
.list-group > .list-item {
  padding: 1em 0;
  border-bottom: solid 1px #e5e5e5;
}
.button,
button {
  align-items: center;
  justify-content: center;
  width: 8em;
  height: 2em;
  margin-left: 0.5em;
  padding: none;
  border-radius: 5px;
  background: linear-gradient(to right, #16c0b0, #84cf6a);
  font-size: 1em;
  color: white;
  border: none;
  outline: none;
}
</style>
